// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as RaiseTicketWrapperCmp from "./RaiseTicketWrapperCmp.bs.js";

function OrderRelatedTicketRootCmp(Props) {
  var crn = Props.crn;
  return React.createElement(RaiseTicketWrapperCmp.make, {
              crn: crn
            });
}

var make = OrderRelatedTicketRootCmp;

export {
  make ,
  
}
/* react Not a pure module */
